<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <rect
            x="3.5"
            y="3.5"
            width="7"
            height="7"
            rx="1.5"
            fill="#ED1C24"
            stroke="#ED1C24"
        />
        <rect
            x="3.5"
            y="13.5"
            width="7"
            height="7"
            rx="1.5"
            fill="#ED1C24"
            stroke="#ED1C24"
        />
        <rect
            x="13.5"
            y="3.5"
            width="7"
            height="7"
            rx="1.5"
            fill="#ED1C24"
            stroke="#ED1C24"
        />
        <rect
            x="13.5"
            y="13.5"
            width="7"
            height="7"
            rx="1.5"
            fill="#ED1C24"
            stroke="#ED1C24"
        />
    </svg>
</template>

<script>
export default {
    name: "BurgerMenuIcon",
    props: {
        color: {
            type: String,
            default: "#282828",
        },
    },
};
</script>

<style lang="scss" scoped>
svg {
    @media (min-width: $screen-m) {
        width: 24px;
        height: 24px;
    }
}
</style>
